export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12671.3d97701f.jpg";